var elevation = {
  '00dp': 'hsl(240, 4%, 95%)',
  '01dp': 'hsl(0, 0%, 99%)',
  '02dp': 'hsl(0, 0%, 99%)',
  '03dp': 'hsl(0, 0%, 99%)',
  '04dp': 'hsl(0, 0%, 99%)',
  '05dp': 'hsl(0, 0%, 99%)'
};
var elevationDark = {
  '00dp': 'hsl(210, 68%, 9%)',
  '01dp': 'hsl(208, 37%, 15%)',
  '02dp': 'hsl(207, 32%, 17%)',
  '03dp': 'hsl(209, 28%, 19%)',
  '04dp': 'hsl(209, 23%, 21%)',
  '05dp': 'hsl(209, 21%, 23%)'
};

export { elevation, elevationDark };
